import { createSelector } from '@reduxjs/toolkit';
import { getDrawerIsOpen } from 'store/appSettings/selectors';
import { getUser } from 'store/session/selectors';

export const headerSelector = createSelector(
    getUser,
    getDrawerIsOpen,

    (user, drawerIsOpen) => ({
        user,
        drawerIsOpen,
    }),
);
